module.exports = __webpack_public_path__ + "img/lainaaja@2x.351655b.png";